// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"_3-z"};